import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { LinkContainer } from 'react-router-bootstrap';

// import { columns } from './gridConfig';
import { Tooltip, message } from 'antd';

// Local Deps
import { getToolingLocationsList } from '../../../graphql/item';
import { LoadingTable } from '../../Loading';
import message1 from '../../../images/m1.png';
import message2 from '../../../images/m2.png';
import './ToolingLocationsSearchGrid.scss';
import setUniversalDetailsHistory from '../../../utils/udHistory';
import history from '../../../config/history';

export default class ToolingLocationsSearchGrid extends Component {
  static propTypes = {
    auth: PropTypes.shape({
      jwtToken: PropTypes.string.isRequired,
      expiration: PropTypes.number.isRequired,
      organizationId: PropTypes.string.isRequired,
      role: PropTypes.string.isRequired,
      cageCode: PropTypes.string.isRequired,

    }).isRequired,
    toolFilter: PropTypes.array,
    updateDisableSearchButtons: PropTypes.func.isRequired,
  };

  static defaultProps = {
    toolFilter: undefined,
  };

  static initialState = {
    tools: [],
    hits: 0,
    pages: 0,
    errors: [],
    isLoading: true,
    toolFilter: undefined,
    showTable: true,
    pageSize: 20,
    sorted: [
      { id: 'partNum', desc: false }
    ],
  };
  state = ToolingLocationsSearchGrid.initialState;

  static getDerivedStateFromProps(nextProps, prevState) {
    // console.log("ToolingLocationsSearchGrid getDerivedStateFromProps")
    if (nextProps.toolFilter !== prevState.toolFilter) {
      // console.log("ToolingLocationsSearchGrid getDerivedStateFromProps if")
      return { toolFilter: nextProps.toolFilter };
    }
    // console.log("ToolingLocationsSearchGrid getDerivedStateFromProps not if")
    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log("ToolingLocationsSearchGrid componentDidUpdate")
    if (prevState.toolFilter !== this.state.toolFilter) {
      // console.log("ToolingLocationsSearchGrid componentDidUpdate if")
      this.remountTable()
    }
  }
  remountTable() {
    this.setState({ showTable: false })
    setTimeout(() => this.setState({ showTable: true }), 5)
  }

  retrieveToolingLocations = async (page, pageSize, sorted) => {
    // console.log("ToolingLocationsSearchGrid retrieveToolingLocations")
    this.setState({ isLoading: true });
    this.props.updateDisableSearchButtons(true);
    const { cageCode } = this.props.auth;
    const filter = this.props.toolFilter;
    const offset = page * pageSize;
    let tools = [];
    let hits = 0;
    try {
      const { itemsSearch } = await getToolingLocationsList(cageCode, offset, pageSize, sorted, filter);
      tools = itemsSearch.itemList || [];
      hits = itemsSearch.hits || 0;
    } catch (error) {
      message.error("Failed to retrieve Tooling Locations List from Database.");
    }

    // if (tools.length > 0) {
    //   let i;
    //   for (i = 0; i < tools.length; i++) {
    //     tools[i].accessLevel = Object.values(JSON.parse(tools[i].accessLevel))[0];
    //     tools[i].category = `${Object.keys(JSON.parse(tools[i].category))[0].toString()}-${Object.values(JSON.parse(tools[i].category))[0].toString()}`;
    //   }
    // }
    const pages = Math.ceil(hits / pageSize)
    this.setState({ tools, hits, pages, isLoading: false });
    this.props.updateDisableSearchButtons(false);
  };

  onPageSizeChange = pageSize => {
    this.setState({ pageSize });
  };

  onSortedChange = sorted => {
    this.setState({ sorted });
  };

  render() {
    const { tools, hits, pages, pageSize, sorted, isLoading } = this.state;
    const columns = [
      {
        Header: 'Part No',
        accessor: 'partNum',
        minWidth: 120,
      },
      {
        Header: 'NSN',
        accessor: 'niin',
        minWidth: 120,
      },
      {
        Header: 'Part Description',
        accessor: 'description',
        minWidth: 250,
      },
      {
        Header: 'Company Name',
        accessor: 'toolLocation',
        minWidth: 300,
      }, {
        Header: 'WSDC',
        accessor: 'wsdc',
        minWidth: 100,
      },
      {
        Header: 'Visibility',
        accessor: 'accessLevel',
        minWidth: 100,
        Cell: cellProps => (
          <div>
            {Object.values(JSON.parse(cellProps.value))[0] || '-'}
          </div>
        ),
      },
      {
        Header: 'Category',
        accessor: 'category',
        Cell: cellProps => (
          <div>
            {/* <Tooltip title={cellProps.value.split('-')[1]}>{cellProps.value.split('-')[0]}</Tooltip> */}
            <Tooltip
              placement="bottomLeft"
              title={
                Object.values(JSON.parse(cellProps.value))[0]
              }
            >
              {Object.keys(JSON.parse(cellProps.value))[0]}
            </Tooltip>
          </div>
        ),
        minWidth: 100,
      },
      {
        Header: 'SOH',
        accessor: 'soh',
        minWidth: 60,
      },
      {
        Header: 'Comments',
        accessor: 'govComment',
        minWidth: 100,
        show: this.props.auth.role === "GOVERNMENT_USER" || this.props.auth.role === "SUPER_ADMIN",
        Cell: cellProps => (
          <LinkContainer
            to="#" // looks like this is required and neededs to be here
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              setUniversalDetailsHistory('toolingSearch', cellProps.original);
              let niin = cellProps.original.niin
                .split('-')
                .join('')
                .trim();
              const partNum = cellProps.original.partNum;
              const cage = cellProps.original.cage;
              if (niin && niin.length > 9) {
                niin = niin.slice(-9);
              }
              history.push(`/details?cage=${cage}&niin=${niin}&partnum=${partNum}&imgClick=Y`);
            }}
          >
            <td className='nf-comment'>
              {cellProps.value !== 'Y' ? (
                <img src={message1} alt="No message available" width="20" height="20" />
              ) : (
                <img src={message2} alt="Message is available" width="20" height="20" />
              )}
            </td>
          </LinkContainer>
        ),
      },
    ];

    return (
      <div className="nf-tooling-mgmt-grid">
        {this.state.showTable && this.state.toolFilter &&
          <Fragment>
            <div>
              <p style={{ fontWeight: '600' }}>Found {hits} Results</p>
            </div>
            <ReactTable
              data={tools}
              pages={pages}
              columns={columns}
              noDataText='Did not find any results matching your query'
              defaultPageSize={pageSize}
              minRows={3}
              showPagination={!isLoading}
              // showPaginationBottom
              showPageJump
              pageSizeOptions={[20, 50, 100, 250, 500]}
              manual // this indicates that server side pagination has been enabled 
              onPageSizeChange={this.onPageSizeChange}
              onSortedChange={this.onSortedChange}
              // filterable
              sortable={!isLoading}
              defaultSorted={sorted}
              multiSort={false}
              loading={isLoading}
              LoadingComponent={LoadingTable}
              onFetchData={(state) => {
                this.retrieveToolingLocations(state.page, state.pageSize, state.sorted)
              }}
              getTdProps={(state, rowInfo) => (
                {
                  onClick: e => {
                    e.preventDefault();
                    setUniversalDetailsHistory('toolingSearch', rowInfo.original);
                    let niin = rowInfo.original.niin
                      .split('-')
                      .join('')
                      .trim();
                    const partNum = rowInfo.original.partNum;
                    const cage = rowInfo.original.cage;
                    if (niin && niin.length > 9) {
                      niin = niin.slice(-9);
                    }
                    history.push(`/details?cage=${cage}&niin=${niin}&partnum=${partNum}`);
                  }
                })
              }
            />
          </Fragment>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grids/ToolingLocationsSearchGrid/ToolingLocationsSearchGrid.jsx